export default __webpack_public_path__ + "static/Gogeta Bike - Employer Guide-c2d07f3abc2263b36a00a0c29c53cdf3.pdf";